<template>
  <div>
    <b-table
      :fields="fields"
      :items="templates[templateMessagePage]"
      show-empty
      responsive
      class="merchant-dashboard__table scroll-area-horizontal">
      <div
        slot="details"
        slot-scope="data"
        class="text-right">
        <span
          class="open-chart"
          @click="openTemplateMessageChart(data.item)">
          <icon name="chart-bar"/>
        </span>
      </div>
      <div
        v-if="!templates.length"
        slot="empty"
        class="no-data text-center">
        <span class="d-block">
          No template messages found.
        </span>
      </div>
    </b-table>
    <div
      v-if="templates.length"
      class="paging clearfix">
      <p class="float-left pages">{{ page }} of {{ templates.length }}</p>
      <button
        :disabled="(page === templates.length)"
        class="btn btn-default btn-paging float-right"
        @click="nextPage">Next</button>
      <button
        :disabled="page === 1"
        class="btn btn-default btn-paging float-right"
        @click="previousPage">Back</button>
    </div>
    <TemplateMessageChartModal
      ref="templateMessageChartModal"
      :dates="dates"
      :chart-labels="chartLabels"/>
  </div>
</template>

<script>
import TemplateMessageChartModal from './modals/TemplateMessageChartModal';

export default {
  name: 'TemplateMessageListsTable',
  components: {
    TemplateMessageChartModal,
  },
  props: {
    templateData: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Object,
      default: () => {},
    },
    chartLabels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 5,
      fields: [
        'keyword',
        {
          key: 'sent',
          label: 'All Sent',
        },
        {
          key: 'failed',
          label: 'All Failed',
        },
        {
          key: 'details',
          label: '',
        },
      ],
    };
  },
  computed: {
    templateMessagePage() {
      return this.page - 1;
    },
    templates() {
      return this.$lodash.chunk(this.templateData, this.pageSize);
    },
  },
  methods: {
    openTemplateMessageChart(template) {
      this.$refs.templateMessageChartModal.loadAnalytics(template);
      this.$refs.templateMessageChartModal.show();
    },
    previousPage() {
      this.page -= 1;
    },
    nextPage() {
      this.page += 1;
    },
  },
};
</script>
